import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import safety from '@devices/settings/device_settings/safety.js';
import relay_pm_app_settings from '@devices/settings/device_settings/app_settings_pm_gen_1.js';
import share from '@devices/settings/device_settings/share.js';
import safety_roller from '@devices/settings/device_settings/safety_roller';
import favorites from '@devices/settings/device_settings/favorites';
import roller_app_setting_gen_2 from '@devices/settings/device_settings/roller_app_setting_gen_2';

export default {
	name: 'shellyswitch25',
	friendly_name: '2.5',
	family: 'relay',
	isPM: true,
	modes: {
		relay: {
			availableViews: ['basic', 'advanced'],
			channels: 2,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer,
				schedule,
				actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'wifi_ap_roaming', component: 'wifi_ap_roaming' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{ title: 'cloud', component: 'cloud' },
					],
				},
				safety,
				relay_pm_app_settings,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'mode', component: 'mode' },
						{ title: 'power_on_default', component: 'power_on_default_rr' },
						{ title: 'long_push', component: 'long_push' },
						{ title: 'button_type', component: 'button_type_rr' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
			hideFromIoActions: ['roller_open_url', 'roller_close_url', 'roller_stop_url'],
		},
		roller: {
			availableViews: ['advanced'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overtemperature'],
			slider: 'current_pos',
			settings: [
				schedule,
				actions,
				safety_roller,
				favorites,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'wifi_ap_roaming', component: 'wifi_ap_roaming' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{ title: 'cloud', component: 'cloud' },
					],
				},
				roller_app_setting_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'mode', component: 'mode' },
						{ title: 'power_on_default', component: 'power_on_default_roller' },
						{ title: 'button_type', component: 'button_type_roller' },
						{
							title: 'open_close_working_time',
							component: 'open_close_working_time',
						},
						{ title: 'ends_delay', component: 'ends_delay', min_ver: '1.12.0' },
						{ title: 'input_buttons_mode', component: 'input_buttons_mode' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{ title: 'swap_inputs', component: 'swap_inputs' },
						{ title: 'reverse_directions', component: 'reverse_directions' },
						{
							title: 'positioning_controls',
							component: 'positioning_controls',
						},
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
			hideFromIoActions: [
				'btn_on_url',
				'btn_off_url',
				'out_on_url',
				'out_off_url',
				'longpush_url',
				'shortpush_url',
			],
		},
	},
};
